import { useState } from 'react'

type PasteValue = string | null
type PasteFn = () => Promise<void>

interface PasteFromClipboardProps {
  onSuccess?: (text: string | null) => void
  onError?: (error?: any) => void
}

export function usePasteFromClipboard({ onSuccess, onError }: PasteFromClipboardProps): {
  pasteValue: PasteValue
  paste: PasteFn
} {
  const [pasteValue, setPasteValue] = useState<PasteValue>(null)

  async function paste() {
    try {
      const pasteText = await navigator.clipboard.readText()
      setPasteValue(pasteText)
      onSuccess?.(pasteText)
    } catch (error: any) {
      setPasteValue(null)
      onError?.(error)
    }
  }

  return { pasteValue, paste }
}
